// Odds display helpers shared by the bet slip. Same fraction rule as Card.vue's convertOdds.

function gcd(a, b) {
  if (b < 0.01) return a;
  return gcd(b, Math.floor(a % b));
}

export function decimalToFraction(decimal) {
  const fraction = Math.round((decimal - 1) * 10) / 10;
  const len = fraction.toString().length - 1;
  let denominator = Math.pow(10, len);
  let numerator = Math.round((fraction * denominator * 10) / 10);
  const divisor = gcd(numerator, denominator);
  numerator /= divisor;
  denominator /= divisor;
  if (Math.floor(numerator) < 0 || Math.floor(denominator) <= 0) {
    return "N/A";
  }
  return `${Math.floor(numerator)}/${Math.floor(denominator)}`;
}

// "1.72" or "8/11" in the user's odds format; "–" when there is no price.
export function formatOdds(decimal, format) {
  if (decimal === null || decimal === undefined || !Number(decimal)) {
    return "–";
  }
  if (format === "decimal") {
    return Number(decimal).toFixed(2);
  }
  return decimalToFraction(Number(decimal));
}

// "+10%" / "−14%" / "0%" for an edge given in percent.
export function formatEdge(edge) {
  if (edge === null || edge === undefined) return "–";
  const rounded = Math.round(edge);
  if (rounded > 0) return `+${rounded}%`;
  if (rounded < 0) return `−${Math.abs(rounded)}%`;
  return "0%";
}

// "value" (green), "novalue" (red) or "neutral" (grey) for an edge in percent.
export function edgeClass(edge) {
  if (edge === null || edge === undefined) return "neutral";
  if (edge >= 5) return "value";
  if (edge <= -5) return "novalue";
  return "neutral";
}

export function formatMoney(amount) {
  if (amount === null || amount === undefined) return "–";
  return `£${Number(amount).toFixed(2)}`;
}

// The decimal price for odds the user typed, or null when it isn't odds. Fractions as "5/1",
// "5-1", "5 to 1", "11/4" or "evens"; with the fractional format a bare "5" is 5/1. Decimal
// as "6" or "6.0" (a fraction typed there still counts).
export function parseOdds(text, format) {
  const value = String(text === null || text === undefined ? "" : text)
    .trim()
    .toLowerCase()
    .replace(",", ".");
  if (!value) return null;
  if (["evens", "even", "evs", "ev"].includes(value)) return 2;
  const fraction = value.match(/^(\d+(?:\.\d+)?)\s*(?:\/|-|:|to)\s*(\d+(?:\.\d+)?)$/);
  if (fraction) {
    const numerator = Number(fraction[1]);
    const denominator = Number(fraction[2]);
    if (!(denominator > 0) || !(numerator > 0)) return null;
    return Math.round((1 + numerator / denominator) * 1000) / 1000;
  }
  if (!/^\d+(?:\.\d+)?$/.test(value)) return null;
  const number = Number(value);
  if (format === "decimal") return number > 1 ? number : null;
  return number > 0 ? 1 + number : null;
}

// What goes in the target-odds box for a decimal price: "4/1" for fractions, "5.0" for decimal.
export function oddsInput(decimal, format) {
  if (format === "decimal") {
    const text = String(Math.round(Number(decimal) * 100) / 100);
    return text.includes(".") ? text : `${text}.0`;
  }
  return decimalToFraction(Number(decimal));
}
